const _envUrl = process.env.REACT_APP_BACKEND_URL;

export const getApiUrl = () => {
  const hostname = window.location.hostname;
  if (hostname === 'maldaturf.in' || hostname === 'www.maldaturf.in') {
    return window.location.origin;
  }
  // On emergent deploy/host domains, use same origin 
  if (hostname.includes('emergent')) {
    return window.location.origin;
  }
  return _envUrl;
};

export const API_URL = getApiUrl();
